<template>
  <b-card
    :header="header"
    no-body>
    <draggable
      v-model="items"
      group="cdmenu"
      class="list-group-flush"
      handle=".drag-title">
      <div
        v-for="(menuItem, i) in items"
        :key="menuItem.id"
        class="list-group-item">
        <div class="d-flex justify-content-between">
          <div
            v-b-toggle="menuItem.id"
            class="drag-title">
            {{ menuItem.label ? menuItem.label : "(Blank Label)" }}
          </div>
          <i
            v-if="canCDMenuEdit"
            class="fa fa-times close"
            style="cursor: pointer"
            @click="$emit('delete-item', menuItem.id)" />
        </div>
        <b-collapse
          :id="menuItem.id"
          accordion="cdmenu">
          <hr>
          <c-d-menu-item-form
            ref="form"
            v-model="items[i]"
            class="mt-3" />
        </b-collapse>
      </div>
    </draggable>
  </b-card>
</template>

<script>
import draggable from "vuedraggable"
import CDMenuItemForm from "@/components/CDMenu/CDMenuItemForm"
import {mapGetters} from "vuex"

export default {
  name: "CDMenuList",
  components: {
    CDMenuItemForm,
    draggable,
  },
  props: {
    value: {
      type: Array,
      default: () => [],
    },
    header: {
      type: String,
      required: true,
    },
  },
  computed: {
    ...mapGetters([
      "canCDMenuEdit",
    ]),
    items: {
      get: function () {
        return this.value
      },
      set: function (value) {
        this.$emit("input", value)
      },
    },
  },
  methods: {
    isValid() {
      // Doing it this way instead of using Array.every() since we don't want to short-circuit on the first failure.
      let allValid = true
      this.items.forEach((it, idx) => {
        const form = this.$refs.form[idx]
        if (!form.isValid()) {
          allValid = false
        }
      })
      return allValid
    },
  },
}
</script>

<style scoped>

</style>
